import type { Company, DeliveryPoint, Site } from "@syllarys/contracts";

/** Les parents sont du contexte ; aucun descendant n'est implicite. */
export function resolvePortfolioSelection(
  companies: Company[],
  sites: Site[],
  points: DeliveryPoint[],
  selection: string,
) {
  const [companyId, siteId, pointId] = selection.split("|");
  const selectedPoint = points.find((point) => point.id === pointId) ?? null;
  const selectedSite =
    sites.find((site) => site.id === (selectedPoint?.siteId ?? siteId)) ?? null;
  const selectedCompany =
    companies.find(
      (company) => company.id === (selectedSite?.companyId ?? companyId),
    ) ?? (companyId === "*" ? null : (companies[0] ?? null));
  return { selectedCompany, selectedSite, selectedPoint };
}
